import { Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

import { useSaveData } from "../../../hooks/useSaveData";
import { assignedToFormSchema } from "./assinged_to-form.schema";
import { useReactHookForm } from "../../../hooks/useReactHookForm";
import { planReviewApiKeyStore } from "../../../api/plan-review-api-key-store";
import { ReactHookForm } from "../../../components/hook-form/react-hook-form.component";
import { FormAutoCompleteSelectDynamic } from "../../query-builder/hooks-form-querybuilder/form-autocomplete-select.dynamic.component";
import { useAuthorize } from "../../../hooks/use-authorize";
import { UserPermissionName } from "../../../models/user-permission-name";

const styling = {
    dialogTitleStyle: { padding: '16px 24px 0' },
    contentPadding: { paddingTop: '30px' },
};

interface AssignedToDialog {
    moduleCode: string;
    planReviewData: any;
    onSubmit: () => void;
    onClosed: () => void;
}

export const AssignedToDialog = ({ moduleCode, planReviewData, onSubmit, onClosed }: AssignedToDialog) => {

    const form = useReactHookForm({
        defaultValues: {
            assignedTo: Number(planReviewData?.userID) ? { userID: Number(planReviewData?.userID), fullName: '' } : null
        },
        yupSchema: assignedToFormSchema
    });

    const { isLoading, mutateAsync } = useSaveData<any>(planReviewApiKeyStore.assignedPlanTask());

    const submitHanlder = async (value: any) => {
        const assingedPlanTask = {
            planReviewTaskID: planReviewData?.planReviewTaskID,
            userID: value?.assignedTo?.userID,
            dashBoardCode: moduleCode,
        }
        await mutateAsync({ data: assingedPlanTask });
        onSubmit();
    };

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <Dialog
            open={true}
            fullWidth={true}
            maxWidth={'sm'}
            // onClose={handleClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
                Assigned To
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClosed}
                sx={{
                    position: 'absolute',
                    right: 10,
                    top: 9,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Tooltip title={<Typography variant="body1">Close</Typography>}>
                    <CloseIcon />
                </Tooltip>
            </IconButton>
            <DialogContent dividers style={styling.contentPadding} className="popupDilog">
                <ReactHookForm formName="ASSIGNED_TO_USER_FORM" onSubmit={submitHanlder} formContextProps={form}>
                    <Grid container spacing={2}>
                        <Grid item lg={12} sm={12} xl={12} xs={12}>
                            <FormAutoCompleteSelectDynamic
                                name="assignedTo"
                                label="Assigned To"
                                getQueryKeyConfig={() => planReviewApiKeyStore.getPlanTaskAssigned(
                                    { planReviwTaskID: planReviewData?.planReviewTaskID, moduleCode: moduleCode })}
                                optionsValueKey="userID"
                                optionsLabelKey="fullName"
                            />
                        </Grid>
                        <Grid item lg={12} sm={12} xl={12} xs={12}>
                            <div className="spaceBetween">
                                <Button variant="outlined" style={{ width: '130px' }} onClick={onClosed}>
                                    Cancel
                                </Button>
                                <Button type='submit' variant="contained" style={{ width: '130px' }}
                                    disabled={isLoading || isReadOnlyPermission}>
                                    Save
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </ReactHookForm>
            </DialogContent>
        </Dialog>
    );
}